import React from 'react';
import DataConservationLayout from './data-conservation-layout';

export default class DataConservation extends React.Component<{}, {}> {
    render() {
        return (
            <DataConservationLayout />
        )
    }
}